import React from "react";
import parse from "html-react-parser";
import parseWithIcons from "../../utils/parseWithIcons";

const ContenuDynamiqueConseil = ({ data }) => {
  return (
    <div className="dynamic conseil">
      {data.wallpaper && (
        <span
          className="wallp"
          style={{
            backgroundImage: `url(${data.wallpaper.localFile.childImageSharp.fluid.src})`,
            backgroundSize: data.wallpaperSize + "%",
          }}
        />
      )}
      <div className="inner">
        <span className="titre">{parse(data.titre)}</span>
        <div className="content">{parseWithIcons(data.texte)}</div>
        {data.image && (
          <div className="image">
            <picture>
              <source
                type="image/webp"
                srcSet={data.image.localFile.childImageSharp.fluid.srcWebp}
                data-srcset={
                  data.image.localFile.childImageSharp.fluid.srcSetWebp
                }
              />
              <source
                type="image/jpeg"
                srcSet={data.image.localFile.childImageSharp.fluid.src}
              />
              <img
                src={data.image.localFile.childImageSharp.fluid.src}
                alt={data.image.altText}
              />
            </picture>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContenuDynamiqueConseil;
